// React
import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// Actions
import { login } from "../../../actions/userActions";

// Internal Components
import { ErrorMessage } from "../../../components/ui/Error/ErrorMessage";

// External Components
import ReactGA from "react-ga4"; // <-- Make sure this is imported

export default function Login({ isModal = false, onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, error, userInfo } = userLogin;

  // In modal mode, userInfo already exists (session expired on the backend but
  // Redux state is still populated). Guard against firing onSuccess immediately
  // on mount — only call it after the user has actually submitted the form.
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (userInfo && userInfo._id) {
      if (isModal && !hasSubmitted.current) {
        // Modal opened while Redux still has stale userInfo — do nothing yet.
        return;
      }

      ReactGA.set({ userId: userInfo._id });
      ReactGA.event("login", { method: "Email" });

      if (isModal) {
        if (onSuccess) onSuccess();
      } else {
        navigate("/today");
      }
    }
  }, [userInfo, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    hasSubmitted.current = true;
    dispatch(login(email, password));
  };

  return (
    <>
      <main className="updateday--container">
        <section className="tile reg">
          <section className="registerContainer">
            {error && <ErrorMessage variant="danger">{error}</ErrorMessage>}
            <div className="input--label">
              <label style={{ fontWeight: "bold", color: "#e2dfcf" }}>
                Login
              </label>
            </div>
            {/* <img
              className="sticker"
              src="https://cdn.sanity.io/images/ou6d2gec/production/088a4919740e18a8e075aea3319a06cbe5dfba5d-4500x4500.png"
              width="25%"
              alt="daily planner"
              loading="lazy"
            /> */}
            <form className="register form" onSubmit={submitHandler}>
              <div className="demographic__row--first">
                <label style={{ color: "#004a22" }} htmlFor="email">
                  Email
                </label>

                <input
                  id="email"
                  className="formInput register"
                  type="email"
                  value={email}
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="off"
                  maxLength={254}
                  required
                />
              </div>

              <div className="demographic__row">
                <label style={{ color: "#004a22" }} htmlFor="password">
                  Password
                </label>

                <input
                  id="password"
                  className="formInput register"
                  type="password"
                  placeholder="Create your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="off"
                  maxLength={128}
                  required
                />
              </div>

              <button className="loginButton" type="submit">
                Login
              </button>

              <span>
                If you haven't already registered, click{" "}
                <a href="/register">here...</a>
              </span>
            </form>
          </section>
        </section>
      </main>
    </>
  );
}
